const ACTIONS = {
  ADD: 'Adicionar',
  ADD_PRODUCT: 'Adicionar produto',
  ADD_PRODUCTS: 'Adicionar produtos',
  ARROW_NEXT: 'next',
  ARROW_PREV: 'previous',
  CANCEL: 'Cancelar',
  CLOSE: 'Fechar',
  CONFIGURE_ALERTS: 'Configurar Alertas',
  DELETE: 'Excluir',
  GO_TO_STORE: 'Ir à loja',
  JOIN: 'Entrar',
  LOAD_MORE: 'Carregar mais',
  READY: 'Pronto',
  REPORT: 'Reportar',
  RETURN: 'Voltar',
  SAVE: 'Salvar',
  SAVE_CHANGES: 'Salvar alterações',
  SEE_MORE: 'Ver mais',
  SEE_OFFER: 'Ver Oferta',
  SELECT_FILE: 'Selecionar arquivo',
  SEND: 'Enviar',
  SHARE: 'Compartilhe',
  SIGN_UP: 'Cadastre-se',
};

export default ACTIONS;
